import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'
import es_es from './lang/es_es'
import en_en from './lang/en_en'
 
Vue.use(MLInstaller)

export default new MLCreate({
  initial: 'es_es',
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('es_es').create(Lang_es_es),  
    new MLanguage('en_en').create(Lang_en_en)
  ]
})
